export default __webpack_public_path__ + "static/media/add-meeting.da0a0ea9.svg";